import { EmployeeScheduleUnAssignedTypesWarningText } from "@/src/features/EmployeeSchedule/getEmployeeScheduleUnAssignedTypesWarningText";
import { AHIcon, AHText , Box , ListItem } from "arkh";


import { useFragment } from "react-relay";

import { FormattedMessage } from "react-intl";
import { graphql } from "relay-runtime";
import { ManageEmployeeSchedueTypesListItem_store$key } from "./__generated__/ManageEmployeeSchedueTypesListItem_store.graphql";

export function ManageEmployeeSchedueTypesListItem(props: {
  onPress: () => void;
  store: ManageEmployeeSchedueTypesListItem_store$key;
}) {
  const store = useFragment(
    graphql`
      fragment ManageEmployeeSchedueTypesListItem_store on Store {
        employeeScheduleTypes {
          id
          assignedTeams {
            id
          }
        }
      }
    `,
    props.store
  );
  const unAssignedTypesLength =
    store.employeeScheduleTypes?.filter(
      (type) => type.assignedTeams.length === 0
    ).length ?? 0;
  return (
    <ListItem
      isFirst
      isLast
      onPress={() => {
        props.onPress();
      }}
      right={<ListItem.NavArrow />}
      footer={
        unAssignedTypesLength > 0 ? (
          <Box
            style={{ flexDirection: "row", alignItems: "center" }}
            spaceTop="xsmall"
          >
            <AHIcon
              type="issue"
              color="negative"
              spaceRight="small"
              size="medium"
            />
            <AHText type="body" style={{ flex: 1 }} numberOfLines={2}>
              <EmployeeScheduleUnAssignedTypesWarningText
                unAssignedTypes={unAssignedTypesLength}
              />
            </AHText>
          </Box>
        ) : null
      }
    >
      <ListItem.Title>
        <FormattedMessage
          defaultMessage="Manage Cost Centers"
          description="Widget Employee Schedule Detail Settings Button"
        />
      </ListItem.Title>
    </ListItem>
  );
}
